import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { useHistory, useLocation } from 'react-router-dom';

import * as paths from 'app-router/paths';
import { useStore } from 'stores';
import { Requester } from 'stores/RequesterStore';

import Loading from 'components/Loading';
import Pagination from 'components/Pagination';
import { ErrorMessage, Message } from 'components/Message';
import { FindIcon, LabeledIcon, ReloadIcon } from 'components/Icon';

import { TabBar } from 'pages/Audience/TabBar';
import { RequesterList } from './TableView';
import { SimpleInlineHelp } from 'components/InlineHelp';

export const Page: React.FC = observer(() =>
{
  const { uiStore, requesterStore } = useStore();
  const history = useHistory();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const pageFromQuery = parseInt(query.get('p') || '1');
  const page = pageFromQuery ? pageFromQuery - 1 : 0;
  const searchQuery = query.get('q') || '';
  const [searchQueryCollector, setSearchQueryCollector] = useState(searchQuery);

  useEffect(() =>
  {
    requesterStore.findAsync(searchQuery, page);
  }, [requesterStore, searchQuery, page]);

  const reloadDataHandler = async () => await requesterStore.findAsync(searchQuery, page);
  const searchHandler = () => history.push(paths.buildRequesterListPath(searchQueryCollector, `${1}`));
  const onPageHandler = (page: number) => history.push(paths.buildRequesterListPath(searchQueryCollector, `${page + 1}`));
  const createRequesterHandler = () => history.push(paths.buildRequesterCreatePath());
  const editRequesterHandler = async (requester: Requester) => history.push(paths.buildRequesterEditPath(requester.token || ''));
  const deleteRequesterHandler = async (requester: Requester) =>
  {
    if (window.confirm(uiStore.labels.pages.audience.deleteRequesterConfirmation.apply({requesterName: requester.name})))
    {
      await requesterStore.deleteAsync(requester.token || '');
      if (!requesterStore.requester.isError)
      {
        await reloadDataHandler();
      }
    }
  };
  return (
    <article className="page audience requester-list">
      <h1>{uiStore.labels.pages.audience.title}<SimpleInlineHelp>{uiStore.labels.help.audience.about}</SimpleInlineHelp></h1>
      <TabBar />
      {
        requesterStore.pagedRequesters.isLoading
        ? <Loading />
        : requesterStore.pagedRequesters.isError
          ? <ErrorMessage>
              {requesterStore.pagedRequesters.errorMessage}
              <button onClick={reloadDataHandler}>
                <LabeledIcon label={uiStore.labels.common.tryAgain}><ReloadIcon/></LabeledIcon>
              </button>
            </ErrorMessage>
          : <div className="content">
              <div className="action-bar">
                <button onClick={reloadDataHandler}><ReloadIcon/></button>
                <button onClick={createRequesterHandler}>{uiStore.labels.pages.audience.createNewRequester}</button>
                <input type="text"
                       className="search"
                       placeholder={uiStore.labels.pages.audience.searchForRequesters}
                       value={searchQueryCollector}
                       onChange={e => setSearchQueryCollector(prev => e.target.value)}
                       onKeyPress={async e => e.key === 'Enter' ? searchHandler() : null}/>
                <button onClick={searchHandler}><FindIcon/></button>
              </div>
              <div className="pagination">
                <Pagination currentPage={requesterStore.pagedRequesters.data?.page || 0}
                            totalPages={requesterStore.pagedRequesters.data?.total || 0}
                            onPage={onPageHandler}/>
              </div>
              {
                requesterStore.pagedRequesters.data?.data && requesterStore.pagedRequesters.data.data.length > 0
                ? <RequesterList requesters={requesterStore.pagedRequesters.data} deleteRequesterHandler={deleteRequesterHandler} editRequesterHandler={editRequesterHandler} />
                : <Message>{uiStore.labels.common.noResults}</Message>
              }
            </div>
      }
    </article>
  );
});